import React from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

/**
 * Renders its children only for a Towpay Admin.
 *
 * The nav already hides admin-only pages from everyone else, so this only catches someone
 * who typed the URL. Without it they would get the page chrome and a 403 from the API.
 */
export function RequireTowpayAdmin({ children }) {
  const { isTowpayAdmin } = useAuth();

  //  children when wrapped directly, Outlet when used as a layout route.
  if (isTowpayAdmin) return children ? <>{children}</> : <Outlet />;

  return (
    <div className="alert alert-warning" role="alert">
      This page is for TowPay admins only.
    </div>
  );
}

export default RequireTowpayAdmin;
